import * as React from 'react'

import {
  AttendanceSettingsTimeSettingsCustomTimeRangeCategoryFragment,
  ExtraHoursRangeFragment,
  PayrollConceptFragment,
  SettingPageCustomTimeRangeFragment,
  WorkTimeCategoriesCompensationsReimbursablePayrollConceptFragment,
  WorkTimeCategoriesContractTaxonomyFragment,
  WorkTimeCategoriesReimbursableSupplementTaxonomyFragment,
} from 'generated/resources/graphql'

import type AttendanceSetting from '../store/models/AttendanceSetting'

interface ContextProps {
  attendanceSetting: AttendanceSetting
  canCreateSettingCategory: boolean
  companyId: number
  contractTaxonomies: WorkTimeCategoriesContractTaxonomyFragment[]
  payrollConcepts: PayrollConceptFragment[]
  customTimeRanges: SettingPageCustomTimeRangeFragment[]
  extraHoursRanges: ExtraHoursRangeFragment[]
  loading: boolean
  payrollEnabled: boolean
  payrollMappingsTaxonomies: WorkTimeCategoriesReimbursableSupplementTaxonomyFragment[]
  payrollMappingsCompensations: WorkTimeCategoriesCompensationsReimbursablePayrollConceptFragment[]
  timeSettingsCategories: AttendanceSettingsTimeSettingsCustomTimeRangeCategoryFragment[]
  specialHoursRegularHoursCompensation: boolean
  hasBankOfHours: boolean
  hasCompensations: boolean
  hasContractHoursBaseline: boolean
}

const Context = React.createContext<ContextProps | null | undefined>(null)

export const AttendanceSettingWorkCategoriesProvider = ({
  value,
  children,
}: {
  value: ContextProps
  children: React.ReactNode
}) => {
  return <Context.Provider value={value}>{children}</Context.Provider>
}

export const useAttendanceSettingWorkCategories = (): ContextProps => {
  const AttendanceSettingWorkCategories = React.useContext(Context)

  if (!AttendanceSettingWorkCategories) {
    throw new Error(
      'useAttendanceSettingWorkCategories must be used within an AttendanceSettingWorkCategoriesProvider'
    )
  }

  return AttendanceSettingWorkCategories
}
